// Static site config + content that doesn't need the DB
export const CONTACT = {
  phone: "+31 6 16467778",
  phoneRaw: "+31616467778",
  whatsapp: "31616467778",
  email: "sparko24.nl@gmail.com",
  kvk: "93357559",
};

export const whatsappLink = (msg = "Hello Sparko, I would like a free quote.") =>
  `https://wa.me/${CONTACT.whatsapp}?text=${encodeURIComponent(msg)}`;

export const STATS = [
  { key: "clients", value: 1200, suffix: "+" },
  { key: "projects", value: 3500, suffix: "+" },
  { key: "experience", value: 12, suffix: "" },
  { key: "satisfaction", value: 100, suffix: "%" },
];

export const CATEGORY_NAMES = {
  general: { en: "General Cleaning", nl: "Algemene Schoonmaak", ar: "التنظيف العام" },
  business: { en: "Business Cleaning", nl: "Zakelijke Schoonmaak", ar: "تنظيف الشركات" },
  deep: { en: "Deep Cleaning", nl: "Dieptereiniging", ar: "التنظيف العميق" },
  floor: { en: "Floor Care", nl: "Vloeronderhoud", ar: "العناية بالأرضيات" },
  glass: { en: "Exterior Cleaning", nl: "Buitenreiniging", ar: "التنظيف الخارجي" },
  carpet: { en: "Carpet & Furniture", nl: "Tapijt & Meubels", ar: "السجاد والأثاث" },
  maintenance: { en: "Maintenance", nl: "Onderhoud", ar: "الصيانة" },
  special: { en: "Special Cleaning", nl: "Speciale Schoonmaak", ar: "التنظيف الخاص" },
  warehouse: { en: "Warehouse & Industry", nl: "Magazijn & Industrie", ar: "المستودعات والصناعة" },
  eco: { en: "Eco Services", nl: "Eco Diensten", ar: "خدمات صديقة للبيئة" },
  custom: { en: "Custom Services", nl: "Maatwerk Diensten", ar: "خدمات مخصصة" },
};

// category meta: icon + representative image key (into IMG)
export const CATEGORY_META = {
  general: { icon: "Sparkles", img: "floor2" },
  business: { icon: "Building2", img: "office3" },
  deep: { icon: "Droplets", img: "deep" },
  floor: { icon: "LayoutGrid", img: "floor2" },
  glass: { icon: "SprayCan", img: "pressure" },
  carpet: { icon: "Armchair", img: "carpet" },
  maintenance: { icon: "Wrench", img: "office2" },
  special: { icon: "Star", img: "postcon" },
  warehouse: { icon: "Factory", img: "sweeper" },
  eco: { icon: "Leaf", img: "eco" },
  custom: { icon: "Settings2", img: "office4" },
};

export const WHY_CHOOSE = [
  { icon: "Users", en: "Experienced Team", nl: "Ervaren Team", ar: "فريق ذو خبرة" },
  { icon: "Wrench", en: "Professional Equipment", nl: "Specialistische Apparatuur", ar: "معدات احترافية" },
  { icon: "Leaf", en: "Eco-Friendly Products", nl: "Milieuvriendelijke Producten", ar: "منتجات صديقة للبيئة" },
  { icon: "ShieldCheck", en: "Reliable & Insured", nl: "Betrouwbaar & Verzekerd", ar: "موثوق ومؤمّن" },
  { icon: "Clock", en: "Fast Response", nl: "Snelle Reactie", ar: "استجابة سريعة" },
  { icon: "BadgeEuro", en: "Affordable Prices", nl: "Betaalbare Prijzen", ar: "أسعار معقولة" },
  { icon: "CalendarClock", en: "Flexible Scheduling", nl: "Flexibele Planning", ar: "جدولة مرنة" },
  { icon: "Heart", en: "100% Satisfaction", nl: "100% Tevredenheid", ar: "رضا 100%" },
];

export const INDUSTRIES = [
  { icon: "Building2", en: "Offices", nl: "Kantoren", ar: "المكاتب", img: "office2", cat: "business" },
  { icon: "GraduationCap", en: "Schools", nl: "Scholen", ar: "المدارس", img: "office1", cat: "business" },
  { icon: "Stethoscope", en: "Hospitals", nl: "Ziekenhuizen", ar: "المستشفيات", img: "hospital", cat: "business" },
  { icon: "UtensilsCrossed", en: "Restaurants", nl: "Restaurants", ar: "المطاعم", img: "restaurant", cat: "business" },
  { icon: "BedDouble", en: "Hotels", nl: "Hotels", ar: "الفنادق", img: "hotel", cat: "business" },
  { icon: "Warehouse", en: "Warehouses", nl: "Magazijnen", ar: "المستودعات", img: "sweeper", cat: "warehouse" },
  { icon: "Factory", en: "Factories", nl: "Fabrieken", ar: "المصانع", img: "factory", cat: "warehouse" },
  { icon: "ShoppingBag", en: "Retail Stores", nl: "Winkels", ar: "المتاجر", img: "retail", cat: "business" },
  { icon: "Building", en: "Apartment Buildings", nl: "Appartementen", ar: "المباني السكنية", img: "residential", cat: "general" },
  { icon: "KeyRound", en: "Property Management", nl: "Vastgoedbeheer", ar: "إدارة العقارات", img: "office3", cat: "maintenance" },
  { icon: "Landmark", en: "Government Buildings", nl: "Overheidsgebouwen", ar: "المباني الحكومية", img: "office2", cat: "business" },
];

export const IMG = {
  hero: "https://images.unsplash.com/photo-1619218070141-bcfeb8b93074?crop=entropy&cs=srgb&fm=jpg&q=85&w=1600",
  commercial: "https://images.unsplash.com/photo-1718152421680-d1580e843cc9?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200",
  residential: "https://images.unsplash.com/photo-1758273238415-01ec03d9ef27?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200",
  hotel: "https://images.unsplash.com/photo-1580842402762-6f5868c17412?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200",
  hotel2: "https://images.unsplash.com/photo-1580256081112-e49377338b7f?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200",
  glass: "https://images.unsplash.com/photo-1741094982607-89ba836dcabd?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200",
  window_high: "https://images.unsplash.com/photo-1512479373983-bd28a541041b?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200",
  facade: "https://images.unsplash.com/photo-1421940943431-d392fcc1079f?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200",
  office1: "https://images.unsplash.com/photo-1577412647305-991150c7d163?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200",
  office2: "https://images.unsplash.com/photo-1718220216044-006f43e3a9b1?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200",
  office3: "https://images.unsplash.com/photo-1556761175-4b46a572b786?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200",
  office4: "https://images.unsplash.com/photo-1715593949273-09009558300a?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200",
  pressure: "https://images.unsplash.com/photo-1718152422704-bd21030a1a99?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200",
  sweeper: "https://images.unsplash.com/photo-1784622526556-add0b02a24b6?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200",
  deep: "https://images.unsplash.com/photo-1737372805905-be0b91ec86fb?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200",
  floor2: "https://customer-assets-rejwkqb3.emergentagent.net/job_sparko-pro/artifacts/vfzswwsl_774825953_1578768456989228_6361741312682528306_n.webp",
  carpet: "https://images.pexels.com/photos/8273517/pexels-photo-8273517.jpeg?auto=compress&cs=tinysrgb&w=1200",
  postcon: "https://images.unsplash.com/photo-1718816281270-ed6ef8357859?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200",
  eco: "https://static.prod-images.emergentagent.com/jobs/9388b454-9a89-4d02-a22b-33ae2d900121/images/514566bf408913902a6acb63aded5c570154c3e4964c45cc1b186b70c9d97414.jpeg",
  founder: "https://customer-assets-rejwkqb3.emergentagent.net/job_sparko-pro/artifacts/d4hhzjcv_IMG_5548.jpeg",
  officeAfter: "https://static.prod-images.emergentagent.com/jobs/9388b454-9a89-4d02-a22b-33ae2d900121/images/83e296693af9b7a2d6a987670c2181327b08c66f7ec1f66f936d46a3c3c41c28.jpeg",
  officeBefore: "https://static.prod-images.emergentagent.com/jobs/9388b454-9a89-4d02-a22b-33ae2d900121/images/6f1b66fa3d43c037c723d4862c04e28ab6de4429ec840ce00f082b8eb5afba38.jpeg",
  hospital: "https://images.pexels.com/photos/37036967/pexels-photo-37036967.jpeg?auto=compress&cs=tinysrgb&w=1200",
  restaurant: "https://images.pexels.com/photos/6375553/pexels-photo-6375553.jpeg?auto=compress&cs=tinysrgb&w=1200",
  retail: "https://images.unsplash.com/photo-1441986300917-64674bd600d8?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200",
  factory: "https://static.prod-images.emergentagent.com/jobs/9388b454-9a89-4d02-a22b-33ae2d900121/images/7558d504a6ffc96ce5da06db9d4fc4245ff5f46ee37bd9686075dad56352f1c9.jpeg",
};

export const PREMIUM = [
  "24/7 Emergency Cleaning", "Same Day Cleaning", "Certified Cleaning Staff", "Fully Insured Services",
  "Satisfaction Guarantee", "Free Site Inspection", "Free Quote within 24 Hours", "Recurring Cleaning Plans",
  "Custom Business Contracts", "Facility Management", "Property Maintenance", "Waste Removal",
  "Airbnb Cleaning", "Holiday Park Cleaning", "Staircase Cleaning", "Parking Garage Cleaning",
];
